import styled, { createGlobalStyle } from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  AI_DARK_GRAY,
  AI_MODAL_BACKGROUND,
  AI_TERTIARY_TEXT,
} from './aiEvaluationTokens'

export const AI_EVALUATION_MODAL_WRAP = 'ai-evaluation-modal-wrap'

export const AiEvaluationModalGlobalStyles = createGlobalStyle`
  .${AI_EVALUATION_MODAL_WRAP} {
    font-family: Roboto, sans-serif;

    .ant-modal-content {
      border-radius: 16px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.24);
      padding: 0;
      overflow: hidden;
      background: ${AI_MODAL_BACKGROUND};
    }

    .ant-modal-header {
      padding: 24px 24px 0;
      border-bottom: none;
      border-radius: 16px 16px 0 0;
      background: transparent;
    }

    .ant-modal-close {
      top: 24px;
      right: 24px;
    }

    .ant-modal-close-x {
      width: 28px;
      height: 28px;
      line-height: 1;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 14px;
        height: 14px;
      }
    }

    .ant-modal-title {
      font-family: Roboto, sans-serif;
      font-weight: 700;
      font-size: 20px;
      line-height: 28px;
      color: ${AI_TERTIARY_TEXT};
    }

    .ant-modal-body {
      padding: 24px;
    }
  }

  .${AI_EVALUATION_MODAL_WRAP}.ai-evaluation-modal-wrap--preview {
    .ant-modal-body {
      padding: 24px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }
  }

  .${AI_EVALUATION_MODAL_WRAP}.ai-evaluation-modal-wrap--error {
    .ant-modal-body {
      padding: 24px;
    }
  }
`

export const GeneratingTitleRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 28px;
`

export const GeneratingTitleIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 28px;
  flex-shrink: 0;
`

export const GeneratingTitleSparkle = styled(FontAwesomeIcon)`
  width: 24px !important;
  height: 14px !important;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.08));

  path {
    fill: url(#rankmiAiGradient);
  }
`

export const ModalAlertWrap = styled.div`
  margin-bottom: 16px;

  .ant-alert {
    border-radius: 8px;
    font-family: Roboto, sans-serif;
    font-size: 14px;
  }
`

export const ErrorLayout = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Roboto, sans-serif;
`

export const ErrorContentArea = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
`

export const ErrorDescription = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  color: ${AI_DARK_GRAY};
`

export const ErrorFooter = styled.div`
  flex-shrink: 0;
  margin: 0 -24px -24px;
  padding: 24px;
  border-top: 1px solid #f0f0f0;
  background: #ffffff;
`

export const ErrorFlagDisabledTitle = styled.h3`
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: ${AI_TERTIARY_TEXT};
`
